import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=a8095aac&scoped=true&"
import script from "./NotificationsButton.vue?vue&type=script&lang=ts&"
export * from "./NotificationsButton.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&id=a8095aac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8095aac",
  null
  
)

export default component.exports